import { getAuthToken, resolveDirectUrl } from '@/api/client'

/**
 * プロダクトのサムネイルをBlobとして取得する
 * 失敗した場合は null を返す（サムネイルは非クリティカル）
 */
export const fetchThumbnailBlob = async (productId: number): Promise<Blob | null> => {
  try {
    const url = resolveDirectUrl(`/p/${productId}/thumbnail`)
    const token = await getAuthToken()
    const headers: HeadersInit = {}
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
    const response = await fetch(url, { headers })
    if (!response.ok) return null
    return await response.blob()
  } catch {
    return null
  }
}
